import { useTranslation } from 'react-i18next'

import { FormPassengersValues } from 'entities/ticket/models/form-passengers'

import { TYPE_AGE } from 'shared/constants'

import { RenderPassengerInfo } from '../render-passenger-info'

import s from './styles.module.scss'

interface Props {
  passengersInfo: FormPassengersValues | null
}

export const PassengerInfo = ({ passengersInfo }: Props) => {
  const { t } = useTranslation()

  let countPassenger = 0

  if (!passengersInfo) return null

  const adults = passengersInfo?.adult
  const child = passengersInfo?.child
  const infant = passengersInfo?.infant

  return (
    <div className={s.container}>
      {adults?.map((item, index) => {
        countPassenger += 1

        return (
          <RenderPassengerInfo
            index={index}
            passenger={item}
            key={`${TYPE_AGE.ADULTS}-${index}`}
            title={`${t('purchase_page.adults_count')} ${countPassenger}`}
          />
        )
      })}

      {child?.map((item, index) => {
        countPassenger += 1

        return (
          <RenderPassengerInfo
            index={index}
            passenger={item}
            key={`${TYPE_AGE.CHILDREN}-${index}`}
            title={`${t('purchase_page.children_count')} ${countPassenger}`}
          />
        )
      })}

      {infant?.map((item, index) => {
        countPassenger += 1

        return (
          <RenderPassengerInfo
            index={index}
            passenger={item}
            key={`${TYPE_AGE.INFANTS_WITHOUT_SEAT}-${index}`}
            title={`${t('purchase_page.infants_count')} ${countPassenger}`}
          />
        )
      })}
    </div>
  )
}
